import { Chain, connectorsForWallets, darkTheme } from '@rainbow-me/rainbowkit';
import { coinbaseWallet, metaMaskWallet, trustWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets';
import { configureChains, createConfig } from 'wagmi';
import { publicProvider } from 'wagmi/providers/public';

const qiChain: Chain = {
  id: 1990,
  name: 'QI Blockchain - Mainnet',
  network: 'qi network',
  iconUrl: 'https://example.com/icon.svg',
  iconBackground: '#fff',
  nativeCurrency: {
    decimals: 18,
    name: 'Qi Blockchain',
    symbol: 'QIE',
  },
  rpcUrls: {
    public: {
      http: ['https://rpc1mainnet.qie.digital'],
      webSocket: ['wss://ws1mainnet.qie.digital'],
    },
    default: {
      http: ['https://rpc1mainnet.qie.digital'],
      webSocket: ['wss://ws1mainnet.qie.digital'],
    },
  },
  blockExplorers: {
    default: {
      name: 'QIcscan',
      url: 'https://mainnet.qie.digital/',
    },
  },
  testnet: false,
  contracts: {
    multicall3: {
      address: '0x13305ab992c3BA30a3f2c4B92727eb4cA64063e8', // This deployed on QIE mainnet v2 
    },
  },
};

const { chains, publicClient, webSocketPublicClient } = configureChains([qiChain], [publicProvider()]);

const projectId = process.env.REACT_APP_PROJECT_ID || '';

export const demoAppInfo = {
  appName: 'QI Platfrom',
};

const connectors = connectorsForWallets([
  {
    groupName: 'Recommended',
    wallets: [
      metaMaskWallet({ projectId, chains }),
      trustWallet({ projectId, chains, shimDisconnect: true }),
      walletConnectWallet({ projectId, chains }),
      coinbaseWallet({ appName: 'Qi Platform', chains }),
    ],
  },
]);

export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
  webSocketPublicClient,
});

export const themeDark = {
  ...darkTheme(),
  colors: {
    ...darkTheme().colors,
    modalBackground: '#100f0f',
    accentColor: 'rgb(150,59,159)',
    accentColorForeground: 'white',
  },
};

export { chains };
